import React from 'react';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { infoPedido } from '../../../../pedidos/apis/servicePedidoConsulta';
import { CabecalhoPedido } from '../../../../pedidos/components/CabecalhoDetalhesPedido';
import { Typography, Accordion, AccordionDetails, AccordionSummary, makeStyles, createStyles, Theme } from "@material-ui/core";
import ReactLoading from 'react-loading';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { TabelaListaItensConsultaPedidos } from "../../../../pedidos/components/TabelaListaItensConsultaPedidos";
import { usePedidos } from '../../../../../contexts/Pedidos';
import { useHistory } from 'react-router-dom';
import { ArrayItensPedido, dadosPedido } from '../../../../pedidos/interfaces';
import { Button } from '../../../../../themes/components/Button';
import { useModals } from '../../../../../contexts/Modals';
import $ from 'jquery';


interface propsModalHistoricoPedido {
    numPed: number;
    codEmp: string;
    showModal: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

let emptPed = {
    cidcli: '',
    codcli: '',
    codcpg: '',
    codctn: '',
    codemp: '',
    codfil: '',
    codfpg: '',
    codgre: '',
    codmot: '',
    codrep: '',
    datapr: '',
    datemi: '',
    datger: '',
    datprv: '',
    descpg: '',
    desfpg: '',
    desmot: '',
    endcli: '',
    horapr: '',
    horger: '',
    nomcli: '',
    nomrep: '',
    nomsup: '',
    numped: '',
    obsped: '',
    pedcrt: '',
    pedori: '',
    przmed: '',
    qtdori: '',
    repsup: '',
    sigufs: '',
    sitped: '',
    tnspro: '',
    vlrori: ''
};


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '97%',
            marginLeft: '1em'
        },
    }),
);


export function ModalDetalhePedidoAprov(props: propsModalHistoricoPedido) {
    let history = useHistory();
    const { buscarItensPedido, buscarHistoricoPed, controleAprovacao, filtrarPedidosAprovacao, pendenciasPedidos } = usePedidos();
    const { mostrarInfoOK, setMensagem, setShowModalInfo } = useModals();
    const [dadosPedido, setDadosPedido] = useState<dadosPedido>();
    const [itensPedido, setItensPedido] = useState<ArrayItensPedido>();
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingItens, setLoadingItens] = useState<boolean>(false);
    const classes = useStyles();
    const numPedido = dadosPedido !== undefined && dadosPedido.numped !== undefined ? dadosPedido.numped : "";
    const codEmp = dadosPedido !== undefined && dadosPedido.codemp !== undefined ? dadosPedido.codemp : "";

    function confirmaAprovacao() {
        setMensagem(
            <div className='mensagem-info-modal-loading'>
                <Typography>{`Deseja aprovar o pedido ${numPedido} ?`}</Typography>
                <Typography>{`Observação:`}</Typography>
                <textarea name="obs-aprov" cols={4} rows={5} id="obs-aprov" style={{ height: '5em', border: '2px solid #ccc', borderRadius: '5px', fontSize: '0.9em', marginRight: '1em', marginBottom: '1em', width: '600px', whiteSpace: 'break-spaces' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button onClick={() => setShowModalInfo(false)} classBtn={"btn-notifications color-default"}>Fechar</Button>
                    <Button onClick={() => [registrarAprovacao(), props.setShowModal(false)]} classBtn={"btn-notifications color-green"}>Sim</Button>
                </div>
            </div>);
        setShowModalInfo(true);
    }

    function confirmaCancelamento() {
        setMensagem(
            <div className='mensagem-info-modal-loading'>
                <Typography>{`Deseja cancelar o pedido ${numPedido} ?`}</Typography>
                <Typography>{`Observação:`}</Typography>
                <textarea name="obs-aprov" cols={4} rows={5} id="obs-aprov" style={{ height: '5em', border: '2px solid #ccc', borderRadius: '5px', fontSize: '0.9em', marginRight: '1em', marginBottom: '1em', width: '600px', whiteSpace: 'break-spaces' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button onClick={() => setShowModalInfo(false)} classBtn={"btn-notifications color-default"}>Fechar</Button>
                    <Button onClick={() => [registrarCancelamento(), props.setShowModal(false)]} classBtn={"btn-notifications color-red"}>Sim</Button>
                </div>
            </div>);
        setShowModalInfo(true);
    }

    function registrarAprovacao() {
        //console.log(props.codEmp);
        $(function () {
            let obsAprov = (document.getElementById("obs-aprov") as HTMLInputElement)?.value;
            setShowModalInfo(false);
            controleAprovacao(numPedido, props.codEmp, obsAprov, "A", history)
                .then(res => {
                    filtrarPedidosAprovacao("", "", props.codEmp, "", "", history);
                    mostrarInfoOK(res);
                })
                .catch(err => {
                    mostrarInfoOK(err);
                })
        })
    }

    function registrarCancelamento() {
        let obsAprov = (document.getElementById("obs-aprov") as HTMLInputElement)?.value;
        setShowModalInfo(false);
        controleAprovacao(numPedido, props.codEmp, obsAprov, "C", history)
            .then(res => {
                filtrarPedidosAprovacao("", "", props.codEmp, "", "", history);
                mostrarInfoOK(res);
            })
            .catch(err => {
                mostrarInfoOK(err);
            })
    }
    function pendenciasDoPedido() {
        setLoading(true);
        setShowModalInfo(false);        
        pendenciasPedidos(numPedido, codEmp, history)
            .then(res => {                
                setMensagem(
                    <div className='mensagem-info-modal-loading'>
                        <Typography>{`Pendências do pedido ${numPedido}`}</Typography>
                        <div style={{ display: "flex", flexDirection: "column", margin: "2px 2px 4px 2px", padding: "2px", width: "500px", height: "450px", overflow: "auto", border: "none" }}>
                            {res.map((x: any) => {
                                return (
                                    <div style={{ display: "flex", flexDirection: "column", margin: "2px 2px 6px 2px", padding:"12px", backgroundColor: "#E8E8E8", justifyContent:'start',}}>
                                        <Typography>{x.solobs ? x.solobs : "Pendência"}</Typography>
                                        <Typography>{x.obsped ? x.obsped : "Pendência"}</Typography>
                                    </div>
                                )
                            })}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Button onClick={() => setShowModalInfo(false)} classBtn={"btn-notifications color-default"}>Fechar</Button>
                        </div>
                    </div>);
                setShowModalInfo(true);
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
                mostrarInfoOK(err);
            })
    } 

    useEffect(() => {
        async function getDadosPedido() {
            await infoPedido(props.numPed, props.codEmp, sessionStorage.getItem("userlogin"), sessionStorage.getItem("logid"))
                .then(res => {
                    setDadosPedido(res[0]);
                    setLoading(false);
                })
                .catch(err => {
                    console.log(err);
                    setLoading(false);
                })
        }
        setDadosPedido(emptPed);
        if (props.showModal === true) {
            setLoading(true);
            if (props.numPed !== 0) {
                getDadosPedido();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.showModal]);

    function buscarItens() {
        async function getDadosItensPedido() {
            ;
            await buscarItensPedido(props.numPed.toString(), props.codEmp, history)
                .then(res => {
                    setItensPedido(res);
                    setLoadingItens(false);
                })
                .catch(err => {
                    console.log(err);
                    setLoadingItens(false);
                })
        }
        if (itensPedido === undefined) {
            setLoadingItens(true);
            getDadosItensPedido();
        }
    }

    return (
        <Modal
            show={props.showModal}
            onHide={() => [props.setShowModal(false), setItensPedido(undefined)]}
            dialogClassName="modal-90w"
            animation={true}
            centered={true}
            size='xl'
        >
            {props.showModal === true &&
                <>
                    <Modal.Header closeButton className={props.codEmp == "2" ? "modal-header-detalhe-pedido" : props.codEmp == "4" ? "modal-header-detalhe-pedido-1" : "modal-header-detalhe-pedido"}>
                        <Modal.Title className="detalhe-pedido-titulo-modal">
                            {loading || dadosPedido === undefined ? <ReactLoading type={"bars"} color={"white"} height={30} width={50} className="detalhe-pedido-titulo-loading" /> :
                                <Typography className="detalhe-pedido-texto-titulo">Detalhes do Pedido {dadosPedido?.numped}</Typography>
                            }
                        </Modal.Title>

                    </Modal.Header>
                    <Modal.Body>
                        {loading || dadosPedido === undefined ? <></> :
                            <div style={{ overflowX: 'scroll' }}>
                                <CabecalhoPedido dadosPedido={dadosPedido} />
                                <div className={classes.root}>
                                    <Accordion className={"tabela-itens-consulta-pedidos-modal"}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                            onClick={() => buscarItens()}
                                        >
                                            <Typography className={"cabecalho-detalhe-form-title show-itens-pedido"}>Itens do Pedido</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            {loadingItens ?
                                                <ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} className="detalhe-pedido-titulo-loading" />
                                                :
                                                <TabelaListaItensConsultaPedidos allowSelectitem={false} listaItens={itensPedido || []} />
                                            }
                                        </AccordionDetails>
                                    </Accordion>
                                    <div className="modal-additens-footer-itens-area">
                                        <div className="modal-additens-footer-info-area">
                                        </div>
                                        <div className="modal-additens-footer-addbotoes-area">
                                            <Button onClick={() => confirmaCancelamento()} classBtn={"btn-footer-novo-pedido color-red"}>Cancelar</Button>
                                            <Button onClick={() => pendenciasDoPedido()} classBtn={"btn-footer-novo-pedido color-default"}>Pendências</Button>
                                            <Button onClick={() => confirmaAprovacao()} classBtn={"btn-footer-novo-pedido color-green"}>Aprovar</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </Modal.Body>
                </>
            }
        </Modal>
    )
}